import { createFileRoute, redirect } from "@tanstack/react-router";
const SLUG = "what-phoenix-homeowners-really-say-about-durafoam-roofing-after-35-years-in-business";
export const Route = createFileRoute("/what-phoenix-homeowners-really-say-about-durafoam-roofing-after-35-years-in-business")({
  beforeLoad: () => { throw redirect({ to: "/blog/$slug", params: { slug: SLUG }, statusCode: 301 }); },
});
